module.exports = __webpack_public_path__ + "static/media/thumbnail-elektronikai-uzem-kivitelezes.81ce37df.jpg";